import { render, staticRenderFns } from "./VehicleProvisionRequest.vue?vue&type=template&id=b0b3d0d2&scoped=true&"
import script from "./VehicleProvisionRequest.vue?vue&type=script&lang=js&"
export * from "./VehicleProvisionRequest.vue?vue&type=script&lang=js&"
import style0 from "./VehicleProvisionRequest.vue?vue&type=style&index=0&id=b0b3d0d2&scoped=true&lang=css&"
import style1 from "./VehicleProvisionRequest.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b3d0d2",
  null
  
)

export default component.exports
import {QCardSection,QBanner,QIcon,QExpansionItem,QItem,QField,QBtnDropdown,QCard,QSeparator,QCheckbox} from 'quasar'
component.options.components = Object.assign({QCardSection,QBanner,QIcon,QExpansionItem,QItem,QField,QBtnDropdown,QCard,QSeparator,QCheckbox}, component.options.components || {})
